export default __webpack_public_path__ + "static/media/phone.1a1662d0.png";